import { Navbar } from "@/projects/FinEaseHome/pages/FinEaseHomePage/Navbar";
import { ReactNode } from "react";
import { Footer } from "@/projects/FinEaseHome/pages/FinEaseHomePage/Footer";

interface ProductLayoutProps {
  children: ReactNode;
}

export const ProductLayout = ({ children }: ProductLayoutProps) => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default ProductLayout;
